import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import ProviderItem from "./item";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import associateServices from "../../services";
import {useInView} from "react-intersection-observer";
import stringHelper from "../../helpers/string-helper";
import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay, Grid, Navigation} from "swiper/modules";
import {miniGamePoints, providerPoints, providersPoints} from "../../helpers/splide-helper";
import './index.css'
import "swiper/css/autoplay";

import store from "../../reducers/createReducers";
import DataActions from "../../actions/data-actions";

const ProviderSlide = ({type = null}) => {
    const {providerList} = useSelector(state => state.dataReducer)
    const {ref, inView} = useInView({
        triggerOnce: true, // Mount the component only once
        threshold: .2, // Mount when 10% of the component is visible
    });
    const {t} = useTranslation()
    const {theme} = useSelector(state => state.globalReducer)
    const [providers, setProviders] = useState([])
    const {i18n} = useTranslation();
    const currentLanguage = i18n.language; // Get the current language

    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (inView && providerList?.length <= 0) {
            setLoading(true)
            associateServices.getGameProviders({
                type
            }).then(res => {
                let updates;
                if (theme === 'light') {
                    updates = res?.data?.map(t => ({...t, image: t?.image?.replace(/light/g, "dark")}))
                    // setProviders(updates)
                } else {
                    updates = res?.data?.map(t => ({...t, image: t?.image?.replace(/dark/g, "light")}))
                    // setProviders(updates)
                }

                store.dispatch(DataActions.setProviderList(updates))

                setLoading(false)
            })
        }

    }, [type, theme, inView, providerList])

    useEffect(() => {
        let updates;
        if (theme === 'light') {
            updates = providerList?.map(t => ({...t, image: t?.image?.replace(/light/g, "dark")}))
            // setProviders(updates)
        } else {
            updates = providerList?.map(t => ({...t, image: t?.image?.replace(/dark/g, "light")}))
            // setProviders(updates)
        }

        store.dispatch(DataActions.setProviderList(updates))

    }, [type, theme])


    useEffect(() => {

        setProviders(providerList)
    }, [providerList])

    if (!loading && providers?.length <= 0)
        return null;

    return (
        <div className="section section--last" ref={ref}>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="section__title-wrap">
                            <h2 className="section__title">{t('general.providers')} ({providers?.length})</h2>
                            <Link
                                to={stringHelper.getLocalizedPath(currentLanguage, '/providers')}
                                className="section__view section__view--carousel">
                                {t('general.view-all')}
                            </Link>
                        </div>
                    </div>
                    <div className="col-12 col-12 mt-2">

                        <Swiper
                            modules={[Autoplay, Navigation, Grid]} // Include the Grid module
                            spaceBetween={8} // Space between slides
                            slidesPerView={2} // This defines 2 slides per row
                            breakpoints={providersPoints}
                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                            }}
                        >
                            {
                                providers?.map(i =>
                                    <SwiperSlide key={i?.id}>
                                        <ProviderItem provider={i}/>
                                    </SwiperSlide>)
                            }
                        </Swiper>


                    </div>
                </div>
            </div>
        </div>

    )

}

export default ProviderSlide
